/**
 * @generated SignedSource<<c4885a8b5c0904cff859b03cc23e56cb>>
 * @relayHash 50dcec71788c6c4a7424da45c4a6cb19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83e5935beee21c2b3345c64df3b5a25fa064de53d53c49837dddf14b8dbaa9a0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateCoverPictureMutationPageDeleteMutation$variables = {
  pageId: string;
  propertyKey: string;
};
export type useUpdateCoverPictureMutationPageDeleteMutation$data = {
  readonly confluence: {
    readonly deletePageProperty: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateCoverPictureMutationPageDeleteMutation = {
  response: useUpdateCoverPictureMutationPageDeleteMutation$data;
  variables: useUpdateCoverPictureMutationPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceDeletePagePropertyPayload",
        "kind": "LinkedField",
        "name": "deletePageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateCoverPictureMutationPageDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateCoverPictureMutationPageDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "50dcec71788c6c4a7424da45c4a6cb19",
    "id": "83e5935beee21c2b3345c64df3b5a25fa064de53d53c49837dddf14b8dbaa9a0",
    "metadata": {},
    "name": "useUpdateCoverPictureMutationPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCoverPictureMutationPageDeleteMutation($propertyKey:String!,$pageId:ID!){confluence{deletePageProperty(input:{key:$propertyKey,pageId:$pageId}){success}}}"
  }
};
})();

(node as any).hash = "4abf0648c818be3efad58cc0f9f2bba2";

export default node;
